import { Navbar } from '../Navigation/Navbar';
import { HeroSection } from './sections/HeroSection';
import { PlayAnywhereSection } from './sections/PlayAnywhereSection';
import { ExclusiveGamesSection } from './sections/ExclusiveGamesSection';
import { AppComingSoonSection } from './sections/AppComingSoonSection';
import { FooterSection } from './sections/FooterSection';
import './WelcomePage.css';

export function WelcomePage() {
  return (
    <div className="welcome-page bg-darker text-white">
      <Navbar />
      <HeroSection />
      <PlayAnywhereSection />
      <ExclusiveGamesSection />
      <AppComingSoonSection />
      <FooterSection />
    </div>
  );
}
